import React, { useEffect, useState } from 'react';
import { getTranslatedText, useIntl } from '@nile/components';
import GlobalAIBot from './GlobalAIBot';
import { GLOBAL_AI_BOT_STATE } from '../helpers';
import RandomText from './RandomText';

const MonicaLoader = ({ loading, classNames, loadingText }) => {
  const intl = useIntl();
  const [loadingRiveState, setLoadingRiveState] = useState(null);

  const monicaLoaderClass = [
    'monica-loader ch-45 position-absolute ai-dark-bg actr w100 flex col actr jctr br10 b0 no-scroll p20',
    classNames && classNames,
    loading ? 'z2 op-1' : 'zm1 op-0'
  ]
    .filter(Boolean)
    .join(' ');

  useEffect(() => {
    setTimeout(() => {
      setLoadingRiveState(GLOBAL_AI_BOT_STATE.Search);
    }, 100);
  }, []);

  return (
    <div className={monicaLoaderClass} id="loader">
      <div>
        <GlobalAIBot riveState={loadingRiveState} stateMachine="Monica_Bot" />
      </div>

      <div className="mt10 tcenter">
        <RandomText
          text={
            loadingText ||
            getTranslatedText(intl, 'reports.report.filter.client.loading')
          }
        />
      </div>
    </div>
  );
};

export default MonicaLoader;
